import { Component, Input, OnInit } from '@angular/core';
import { WaseelWidgetService } from '../../shared/services/waseel-widget.service';

@Component({
  selector: 'waseel-widget-loader',
  standalone: true,
  template: ``,
  styles: []
})
export class WaseelWidgetLoaderComponent implements OnInit {

  @Input() environment: 'production' | 'staging' = 'production';
  @Input() delay = 0;

  constructor(private widgetService: WaseelWidgetService) {}

  ngOnInit(): void {
    this.widgetService.loadWidget(this.environment, this.delay);
  }
}